<mat-card class="card" (mouseenter)="showLegend = true" (mouseleave)="showLegend = false"> 
    <mat-card-header>
        <button mat-icon-button *ngIf="showLegend" (click)="openLegend($event)" style="position: absolute; right: 3px; top: 3px;"><mat-icon>help_outline</mat-icon></button>
        <mat-card-subtitle></mat-card-subtitle>
        <mat-card-title style="margin-top: 10px !important;">{{test.title.toUpperCase()}}</mat-card-title>
    </mat-card-header>
    <mat-card-content style="height: 100%;">
        <mat-chip-listbox>

            <mat-chip class="colored-chip" matTooltip="{{ getCIATooltip(test) }}" matTooltipClass="break-line-tooltip">
                <span *ngFor="let letter of getCIAArray()"
                    [ngStyle]="{'color': checkCIA(test, letter) ? 'white' : '#ffffffbf', 'font-weight': checkCIA(test,letter) ? '550' : 'unset'}">
                    {{ letter }}
                </span>
            </mat-chip>
            <mat-chip class="colored-chip" matTooltip="{{ getSTRIDETooltip(test) }}" matTooltipClass="break-line-tooltip">
                <span *ngFor="let letter of getSTRIDEArray()"
                    [ngStyle]="{'color': checkSTRIDE(test, letter) ? 'white' : '#ffffffbf', 'font-weight': checkSTRIDE(test,letter) ? '550' : 'unset'}">
                    {{ letter }}
                </span>
            </mat-chip>
        </mat-chip-listbox>
        <!-- <mat-chip-listbox>
            <ng-container *ngFor="let unece of test.unr155annex5mapping">
                <mat-chip class="unece-chip" matTooltip="{{ extractTextUnece(unece) }}">
                    {{ extractSLT(unece) }}
                </mat-chip>
            </ng-container>
        </mat-chip-listbox> -->
        <ng-container *ngIf="test.unr155annex5mapping.length > 0">
            <mat-accordion>
                <mat-expansion-panel (opened)="panelOpenState = true"
                (closed)="panelOpenState = false" (click) = "$event.stopPropagation();" class="regulations-mat-expansion-panel">
                <mat-expansion-panel-header class="card-mat-expansion-panel-header">
                    <mat-panel-title>Regulations</mat-panel-title>
                </mat-expansion-panel-header>
                    <mat-chip-listbox>
                        <ng-container *ngFor="let unece of test.unr155annex5mapping">
                            <mat-chip
                            [class.gb-chip]="extractRegulationId(unece)?.startsWith('GB')"
                            [class.unece-chip]="extractRegulationId(unece)?.startsWith('slt')"
                            [class.red-chip]="extractRegulationId(unece)?.startsWith('RED')"
                            matTooltip="{{ extractTextRegulation(unece) }}" (click) = "onUneceChipClick($event, extractRegulationId(unece))">
                                {{ extractRegulationId(unece) }} 
                            </mat-chip>
                        </ng-container>
                    </mat-chip-listbox>
                </mat-expansion-panel>
            </mat-accordion>
        </ng-container>
        <p class="summary-text">{{test.summary}}</p>
    </mat-card-content>
    <mat-divider></mat-divider>

    <mat-chip-listbox>
        <ng-container *ngFor="let variation of test.targets">
            <mat-chip-row class="iface-chip" (click) = "onIfaceChipClick($event, variation)"
                [editable]="false">
                {{variation}}
            </mat-chip-row>
        </ng-container>
    </mat-chip-listbox>
    <mat-card-footer>
        <!-- <mat-progress-bar mode="indeterminate"></mat-progress-bar> -->
    </mat-card-footer>
</mat-card>
